import { Button, OnboardingWrapper } from "toptaal-shared"
import { createFileRoute, useRouter } from "@tanstack/react-router"

export const Route = createFileRoute("/onboarding/ongeldige_token")({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()

  return (
    <OnboardingWrapper title="Deze link is niet meer geldig.">
      <p className="text-center -mt-8">
        Neem contact op met TopTaal om een nieuwe link te ontvangen.
      </p>

      <Button
        onClick={() => router.navigate({ to: "/login" })}
        className="mt-8 w-fit mx-auto"
      >
        Terug naar login
      </Button>
    </OnboardingWrapper>
  )
}
